import styled from 'styled-components';

export const ContainerStudies = styled.div`
  padding: var(--spacing-3xl) var(--spacing-xl);
  min-height: calc(100vh - 200px);
  background-color: var(--bg-main);
  margin: 0;

  .page-header {
    margin-bottom: var(--spacing-3xl);
    
    h2 {
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      margin-bottom: var(--spacing-sm);
      font-size: var(--font-size-2xl);
    }
    
    p {
      font-size: var(--font-size-lg);
      margin-bottom: 0;
      color: var(--text-secondary);
    }
  }

  .filter-section {
    background: var(--bg-light);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-2xl);
    margin-bottom: var(--spacing-2xl);
    box-shadow: var(--shadow-md);
    border: none;
  }

  .table-section {
    background: var(--bg-light);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-2xl);
    box-shadow: var(--shadow-md);
    border: none;
  }

  table {
    margin-bottom: 0;
    font-size: var(--font-size-sm) !important;

    th {
      background-color: var(--gray-100);
      border-top: none;
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      padding: var(--spacing-lg);
    }

    td {
      padding: var(--spacing-lg);
      vertical-align: middle;
      color: var(--text-muted);
      border-color: var(--gray-200);
    }

    tbody tr:hover {
      background-color: var(--gray-100);
    }
  }

  .filter {
    display: flex;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-lg);
  }

  th:nth-of-type(2) {
    width: 20vw;
  }
  th:nth-of-type(3) {
    width: 10vw;
  }
  th:nth-of-type(4) {
    width: 10vw;
  }
  th:nth-of-type(7) {
    width: 80px;
  }

  /* Estilos específicos para o menu de ações moderno */
  .action-menu-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Melhorar responsividade da tabela */
  .table-responsive {
    border-radius: var(--border-radius-md);
    overflow: hidden;
  }

  /* Ajustar padding das células para o novo menu */
  table td:last-child {
    padding: var(--spacing-sm);
  }
  
  @media (max-width: 1180px) {
    width: 100%;
    float: none !important;
    margin-left: 0px !important;
    padding: var(--spacing-md);
  }
`;

export const ContainerLoading = styled.div`
  height: calc(100vh - 7.5rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-light);

  h1 {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    color: var(--primary-color);
    text-align: center;
    margin-top: var(--spacing-lg);
  }
`;
